import React from "react"

export default class SendEmailButton extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.table_action) {
      var emails = this.props.table_action.emails.map((email, idx) => {
        var href = this.props.table_action.path.replace(/\$id/g, email.id);
        return <li key={idx} className="dropdown-item"><a className="modal-iframe" data-fullscreen="true" href={href}>{email.name}</a></li>
      })
    }
    return (
      <div className={"btn-group"}>
        <button type="button" className={"btn btn-primary dropdown-toggle "} data-toggle="dropdown">
          {I18n.t(this.props.table_action.label)} <span className="caret"></span>
        </button>
        <ul className="dropdown-menu" role="menu">
          {emails}
        </ul>
      </div>
    )
  }
};
